import { Flex, FlexProps, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

export const MenuOpenerButton: React.FC<
  { children: React.ReactNode } & FlexProps
> = ({ children, ...props }) => {
  const bg = useColorModeValue('text.lightGrey', 'background.dark.hover');
  const borderColor = useColorModeValue('gray.100', 'whiteAlpha.200');
  const color = useColorModeValue('text.darkGray', 'text.dark.primary');

  return (
    <Flex
      p="14px"
      borderRadius="lg"
      borderWidth="1px"
      color={color}
      fontSize="md"
      fontFamily="marketingPage"
      fontWeight="normal"
      borderColor={borderColor}
      bg={bg}
      {...props}>
      {children}
    </Flex>
  );
};
